/**
 * MKPlayer custom error codes & messages.
 * @internal
 */
export const MKCustomError = {
    /**
     * Unkown error.
     */
    Unknown: {
        code: "123",
        message: "Unknown error."
    },

    /**
     * HTTP error (including 4xx & 5xx errors).
     */
    Http: {
        code: "125",
        message: "HTTP Error."
    },

    /**
     * HTTP request timeout or aborted.
     */
    HttpAbort: {
        code: "126",
        message: "HTTP request timeout or aborted."
    }
};
Object.freeze(MKCustomError);